var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "driveFileList"
    }
  }, [_c('md-toolbar', [_c('md-input-container', {
    staticClass: "filter",
    staticStyle: {
      "flex": "1"
    }
  }, [_c('label', [_vm._v("Filter")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.create
    }
  }, [_c('md-icon', [_vm._v("add")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom"
    }
  }, [_vm._v("Create new file")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.refresh
    }
  }, [_c('md-icon', {
    staticClass: "status-icon md-primary",
    class: {
      'pending': _vm.refreshStatus === 'pending'
    }
  }, [_vm._v("refresh")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom"
    }
  }, [_vm._v("Refresh the file list")])], 1)], 1), _vm._v(" "), _c('md-list', {
    staticClass: "md-double-line file-list"
  }, _vm._l((_vm.filteredFiles), function(file) {
    return _c('DriveFileListItem', {
      key: file.id,
      attrs: {
        "file": file
      }
    })
  }))], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c46823d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DriveFileList.vue
// module id = ENgG
// module chunks = 1